import { Parser } from '~/api';
import { AddonCatalogEntry } from '~/api/models';
import RequestService from './request';

class AddonsService {
    list(): Promise<AddonCatalogEntry[]> {
        return RequestService.get('/addons').then((response) => Parser.parse(response, true));
    }

    // Debug builds only -- billing owns activation everywhere else.
    toggle(name: string, active: boolean): Promise<void> {
        return RequestService.patch(`/addons/${name}`, { active });
    }

    // One call rather than one per addon: the overrides are a single stored blob,
    // so parallel writes would clobber each other.
    toggleAll(active: boolean): Promise<void> {
        return RequestService.patch('/addons', { active });
    }
}

export default new AddonsService();
